export function normalizeTournamentRegionToPlatform(
  raw: string | null | undefined,
): string | null {
  const r = String(raw ?? "").trim();
  if (!r) return null;

  const u = r.toUpperCase();

  if (
    u.length >= 3 &&
    /[A-Z]/.test(u[0] ?? "") &&
    /[A-Z]/.test(u[1] ?? "") &&
    (u.endsWith("1") || u.endsWith("2"))
  ) {
    return u;
  }

  switch (u) {
    case "EUW":
      return "EUW1";
    case "EUNE":
    case "EUN":
      return "EUN1";
    case "NA":
      return "NA1";
    case "BR":
      return "BR1";
    case "LAN":
      return "LA1";
    case "LAS":
      return "LA2";
    case "OCE":
    case "OC":
      return "OC1";
    case "TR":
      return "TR1";
    case "RU":
      return "RU";
    case "JP":
      return "JP1";
    case "SEA":
      return "SG2";
    default:
      return u;
  }
}

export function normalizeAccountRegionToPlatform(
  raw: string | null | undefined,
): string | null {
  const a = String(raw ?? "").trim();
  if (!a) return null;
  const u = a.toUpperCase();
  if (u === "SEA") return "SG2";
  return u;
}

export function isAccountAllowedForTournamentRegion(
  tournamentRegionRaw: string | null | undefined,
  accountRegionRaw: string | null | undefined,
): boolean {
  const t = normalizeTournamentRegionToPlatform(tournamentRegionRaw);
  if (!t) return true;

  const a = normalizeAccountRegionToPlatform(accountRegionRaw);
  if (!a) return true;

  return t === a;
}

export function filterAccountsForTournamentRegion<
  T extends { region?: string | null },
>(
  accounts: T[],
  tournamentRegionRaw: string | null | undefined,
): T[] {
  const t = normalizeTournamentRegionToPlatform(tournamentRegionRaw);
  if (!t) return accounts;
  return accounts.filter((acc) =>
    isAccountAllowedForTournamentRegion(t, acc?.region ?? null),
  );
}

